import React from 'react';
import { FailureStatus } from 'src/common/ui/StatusScreen';

/**
 * Page shown when the bootstrap `getUserProfile` call fails.
 *
 * Rendered by the {@link ./AppBootstrap} gate in place of its children, at
 * whatever URL the user is on — the failure does not move them. Purely
 * presentational as a result: recovery is the gate's job, since a reload
 * re-issues the query and renders the app if it succeeds, which is what makes
 * "refresh this page to try again" true.
 */
const ProfileUnavailablePage: React.FC = () => (
  <FailureStatus heading="Couldn’t load your profile">
    <p>Refresh this page to try again.</p>
  </FailureStatus>
);

export default ProfileUnavailablePage;
